import useSWR from 'swr';
import { fetchPopularProducts } from './data-source';

export function usePopularProductsService() {
  const { data, isLoading } = useSWR(
    '/api/products/populars',
    fetchPopularProducts,
    {
      suspense: true,
    }
  );

  return { data, isLoading };
}
